export default "__VITE_ASSET__bbf96ea8__"